import {
  PuCoverage,
  PuDetail,
  PuKpi,
  PuRow
} from '@/common/model/productUnderstanding'

export const ProductUnderstandingApiPath = {
  LIST: '/api/sites/{site_id}/product-understanding',
  COVERAGE: '/api/sites/{site_id}/product-understanding/coverage',
  ESTIMATE: '/api/sites/{site_id}/product-understanding/estimate',
  RUNS: '/api/sites/{site_id}/product-understanding/runs',
  CANCEL_RUN: '/api/sites/{site_id}/product-understanding/runs/{run_id}/cancel',
  DETAIL: '/api/sites/{site_id}/product-understanding/{product_id}'
} as const

export type ProductUnderstandingApiPath =
  (typeof ProductUnderstandingApiPath)[keyof typeof ProductUnderstandingApiPath]

export interface ListPuVars {
  site_id: number
  q?: string
  status?: string
  page?: number
  per_page?: number
}

export interface CoveragePuVars {
  site_id: number
}

export interface DetailPuVars {
  site_id: number
  product_id: string
}

export interface PuListResponse {
  items: PuRow[]
  total: number
  kpi: PuKpi
}

export type PuCoverageResponse = PuCoverage
export type PuDetailResponse = PuDetail


// ------------------------------------------------------------------
// 実行（openspec: product-understanding-run-and-billing）
// ------------------------------------------------------------------

export interface PuEstimateVars {
  site_id: number
}

/** 実行前の見積り。**これを取得するまで実行させない** */
export interface PuEstimateResponse {
  total_products: number
  pending: number
  new: number
  changed: number
  /** LLM を呼ばずスキップする商品。費用に数えない */
  thin: number
  /** 実際に課金対象になる件数 */
  billable: number
  estimated_prompt_tokens: number
  estimated_completion_tokens: number
  estimated_cost_usd: number
  /** site=そのサイトの実績 / global=全体の実績 / fallback=実績なし（精度が低い） */
  accuracy: 'site' | 'global' | 'fallback'
  avg_prompt_tokens: number
  avg_completion_tokens: number
  margin: number
}

export interface PuRun {
  id: number
  trigger: 'manual' | 'schedule' | 'cli'
  status: 'running' | 'complete' | 'cancelled' | 'error'
  total_products: number
  pending: number
  processed: number
  deferred: number
  prompt_tokens: number
  completion_tokens: number
  cost_usd: number
  cancel_requested: boolean
  started_at: string | null
  finished_at: string | null
  error: string | null
  /** 進行中のみ。実績が無いうちは null（当てずっぽうのETAを出さない） */
  eta_seconds: number | null
}

export interface PuRunsVars {
  site_id: number
}

export interface PuRunsResponse {
  running: PuRun | null
  items: PuRun[]
}

export interface StartPuRunVars {
  site_id: number
}

export interface CancelPuRunVars {
  site_id: number
  run_id: number
}
